import React from "react";
import { useNavigate } from "react-router-dom";
import videoAccueil from "../../img/Accueil_mainvideo.MOV";
import accueilMood from "../../img/logo-mood-blanc-home-page.png";
import choisiTaPiece from "../../img/accueil_concept1.jpg";
import installeToi from "../../img/accueil_concept2.jpg";
import decoEtCree from "../../img/accueil_concept3.jpg";
import cuisson from "../../img/accueil_concept4.png";
import oeuvre from "../../img/accueil_concept5.jpg";

const Accueil = () => {
  const navigate = useNavigate();

  const conceptRows = [
    {
      title: "1. Choisi ta pièce",
      description: [
        "Un large choix de pièces en céramique, vaisselle ou déco,",
        "c’est selon ton mood !", "Nos pièces commencent des 10 euros et jusqu'à 60 euros."
      ],
      background: null,
      image: choisiTaPiece,
    },
    {
      title: "2. Installe-toi",
      description: [
        "Couleurs, pinceaux, accessoires... tout est prévu!",
        "(même si tu veux boire ou manger un p’tit quelque chose).",
      ],
      background: null,
      image: installeToi,
    },
    {
      title: "3. Déconnecte & crée",
      description: [
        "Mets ton cerveau sur pause (et ton smartphone en mode avion)",
        "Et laisse parler ta créativité.",
      ],
      background: null,
      image: decoEtCree,
    },
    {
      title: "4. On cuit ta pièce",
      description: [
        "On récupère ta pièce pour l’émailler et la cuire à 1000°,",
        "la magie opère.",
      ],
      background: null,
      image: cuisson,
    },
    {
      title: "5. Récupère ton chef-d'oeuvre",
      description: [
        "Environ 2 semaines plus tard, il est à toi.",
        "Fierté garantie !",
      ],
      background: null,
      image: oeuvre,
    },
  ];

  return (

    <div className="w-screen min-h-screen flex flex-col items-center justify-center gap-12">
      <section className="w-full flex flex-col items-center">
        <div className="relative w-full overflow-hidden">
          <video
            className="w-full object-cover"
            src={videoAccueil}
            poster="/picto-accueil.png"
            autoPlay
            muted
            loop
            playsInline
          >
            Votre navigateur ne supporte pas la vidéo.
          </video>
          <div className="absolute inset-0 flex flex-col gap-6 md:gap-10 items-center justify-center md:justify-start lg:justify-start pointer-events-none">
            <img
              src={accueilMood}
              alt="Accueil mood"
              className="h-28 md:h-44 lg:h-44 w-auto drop-shadow-lg md:mt-16 lg:mt-36"
            />
            <button
              className="pointer-events-auto bg-[#ffffff31] border-white border-2 text-white px-4 py-2 rounded-lg text-lg md:text-2xl text-center shadow-md hover:bg-[#ffffff70] transition-colors"
              onClick={() => navigate("/reservations")}
            >
              Réserver
            </button>
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-10 lg:px-36 flex flex-col gap-14 mt-16 mb-20">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-orange-600">
          Le Concept
        </h2>

        <div className="flex flex-col gap-10">
          {conceptRows.map((row, index) => {
            const isEven = index % 2 !== 0;
            const layoutClass = isEven ? "md:flex-row-reverse" : "md:flex-row";
            return (
              <div
                key={row.title}
                className={`flex flex-col ${layoutClass} gap-6 md:gap-10 items-center md:items-stretch`}
              >
                <div
                  className="relative flex-1 rounded-2xl overflow-hidden text-white p-8 min-h-[280px] md:min-h-[320px] max-h-[320px] flex mx-auto justify-center items-center h-full"
                  style={{
                    backgroundImage: `url(${row.background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="relative z-10 flex flex-col gap-4 max-w-xl item-center">
                    <h3 className="text-2xl md:text-3xl font-bold text-orange-800 text-center mb-10">
                      {row.title}
                    </h3>
                    <div className="text-orange-900 text-base md:text-lg leading-relaxed text-center item-center">
                      {row.description.map((desc, descIndex) => (
                        <p key={descIndex}>{desc}</p>
                      ))}
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-transparent to-white/10 pointer-events-none" />
                </div>

                <div className="flex-1 overflow-hidden min-h-[280px] md:min-h-[320px] max-h-[320px] flex items-center justify-center bg-transparant h-full">
                  <div className="rounded-lg">
                  <img
                    src={row.image}
                    alt={row.title}
                    className="h-full w-full max-h-[320px] object-contain rounded-lg"
                  />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Accueil;
